import PageHero from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { useSite } from "../context/SiteContext";

export default function Departments() {
  const { departments, settings } = useSite();
  const p = settings.pages.department;
  return (
    <div data-testid="department-page">
      <PageHero label={p.label} title={p.title} subtitle={p.subtitle} />
      <section className="bg-bone py-20 md:py-28">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-line border border-line">
            {departments.map((d, i) => (
              <Reveal key={d.id || d.name || i} delay={(i % 3) * 0.05}>
                <div data-testid="department-item" className={`p-8 md:p-10 h-full group transition-colors duration-300 ${d.partner ? "bg-forest text-bone" : "bg-bone hover:bg-forest"}`}>
                  <div className="flex items-center justify-between">
                    <span className="font-mono text-sm text-gold">{String(i + 1).padStart(2, "0")}</span>
                    <span className={`text-[10px] uppercase tracking-widest px-2.5 py-1 rounded-full border ${d.partner ? "border-gold text-gold" : "border-line text-forest/50 group-hover:text-bone/60 group-hover:border-bone/30"}`}>{d.university}</span>
                  </div>
                  <h3 className={`font-serif text-2xl md:text-3xl mt-6 transition-colors ${d.partner ? "text-bone" : "text-forest group-hover:text-bone"}`}>{d.name}</h3>
                  <p className={`leading-relaxed mt-4 transition-colors ${d.partner ? "text-bone/70" : "text-muted group-hover:text-bone/60"}`}>{d.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
